<template>
  <div class="record">
    <van-sticky>
      <van-nav-bar :border="false" >
        <template #title>
          <strong>提现记录</strong>
        </template>
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.replace('/withdraw')"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-pull-refresh v-model="isLoading" class="flex-1" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        @load="onLoad"
      ><div class="card-list">
          <div v-for="item in record" :key="item.id" class="card-item">
            <header class="flex justify-between align-center">
              <strong>
                <span>提现金额：</span>
                <span>￥{{ item.money }}</span>
              </strong>
              <div class="color-9DA4B3 flex align-center" @click="isShow = !isShow">
                {{ !isShow ? '收起' : '展开'}}
                <van-icon :name="isShow ? 'arrow-down' : 'arrow'" class="ml-5" />
              </div>
            </header>
            <section>
              <p>
                <span>提现日期：</span>
                <span>{{ item.createtime | formatTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
              </p>
              <p>
                <span>CP名称：</span>
                <span>{{ item.nickname }}</span>
              </p>
              <div ref="block" class="block" :class="{ 'close': isShow }">
                <p>
                  <span>开户行：</span>
                  <span>{{ item.bank_name }}</span>
                </p>
                <p>
                  <span>银行账号：</span>
                  <span>{{ item.account_no }}</span>
                </p>
                <p>
                  <span>实际到账金额：</span>
                  <span>{{ item.after_tax_money }}</span>
                </p>
                <p class="flex align-center">
                  <span>提现状态：</span>
                  <van-tag :type="types[item.status]">{{ item.status_text }}</van-tag>
                  <van-icon v-if="item.status === 2" name="question-o" class="ml-10" @click="$dialog.alert({ message: item.remark })" />
                </p>
                <p>
                  <span>账户余额：</span>
                  <span>{{ item.balance }}</span>
                </p>
                <p>
                  <span>收款人：</span>
                  <span>{{ item.name }}</span>
                </p>
              </div>
            </section>
          </div>
        </div>
        <template v-if="record.length > 0" #finished>
          <span>没有更多了</span>
        </template>
        <van-empty v-if="record.length === 0" description="暂无数据" />
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { withdrawList } from '@/api/common.js'
export default {
  name: 'WithdrawRecord',
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      isShow: false,
      currentPage: 0,
      record: []
    }
  },
  computed: {
    types() {
      return {
        0: 'warning',
        10: 'success',
        20: 'danger'
      }
    }
  },
  async created() {
    this.$store.commit('TOGGLE_LOADING', true)
    await this.onLoad()
    this.$store.commit('TOGGLE_LOADING', false)
  },
  methods: {
    async withdrawList(type) {
      const status_text = {
        0: '申请提现',
        10: '已拒绝',
        20: '提现成功'
      }
      const res = await withdrawList({ page: this.currentPage })
        const data = res.data.data_list
        const list = data.data.map(val => ({
          id: val.id,
          money: val.money,
          createtime: val.createtime * 1000,
          account_no: val.account_no,
          after_tax_money: val.after_tax_money,
          bank_name: val.bank_name + `(${val.bank_branch})`,
          balance: val.balance,
          name: val.name,
          status_text: status_text[val.status],
          status: val.status,
          remark: val.remarks
        }))
        if (type === 'refresh') {
          this.record = list
        } else {
          this.record = [...this.record, ...list]
        }
        return list.length
    },
    async onLoad() {
      this.loading = true
      this.currentPage = this.currentPage + 1
      const length = await this.withdrawList()
      if (length < 1) {
        this.finished = true
      }
      this.loading = false
    },
    async onRefresh() {
      this.currentPage = 1
      await this.withdrawList('refresh')
      this.$toast('刷新成功')
      this.isLoading = false
      this.finished = false
    }
  }
}
</script>

<style lang="scss" scoped>
.record{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: auto;
  /deep/ .van-pull-refresh__track{
    min-height: 100vh;
  }
}
.card-list{
  padding: 0 15px;
  .card-item{
    margin: 15px 0;
    box-shadow: 0 0 8px 0 #e5e5e5;
    border-radius: 10px;
    overflow: hidden;
    header{
      padding: 15px;
      border-bottom: 1px solid #e5e5e5;
    }
    section{
      line-height: 25px;
      padding: 15px;
      p{
        span{
          display: inline-block;
          font-weight: 400;
          &:nth-of-type(1){
            width: 110px;
            margin-right: 15px;
          }
        }
      }
      .block{
        height: 150px;
        transition: all .2s linear;
      }
      .close{
        height: 0;
        overflow: hidden;
      }
    }
  }
}
</style>
